import { SetStateAction } from "react";
import { Grid2 } from "@mui/material";
import { Rotate90DegreesCw } from "@mui/icons-material";
import { FloorZoomMode } from "../../../Domain/Types/FloorZoomMode.type";
import { handleZoomToHighlight } from "./DisplayFloorPlanView.functions";
import JumpIcon, { IconContainer } from "../../Canvas/Partials/jump-icon.component";

export function DisplayToolbarIcons({
  floorZoomMode,
  jumpIconColor,
  setFloorZoomMode,
  setFloorRotation
}: Readonly<{
  floorZoomMode: FloorZoomMode;
  jumpIconColor: string;
  setFloorZoomMode: (mode: FloorZoomMode) => void;
  setFloorRotation: (value: SetStateAction<number>) => void;
}>) {
  return (
    <Grid2 container data-testid="display-toptoolbar-icon-groups">
      <Grid2>
        <div
          style={{
            position: "relative",
            zIndex: 1,
            border: "none",
            background: "none",
            padding: 0,
            cursor: "pointer"
          }}
          aria-label="Zoom to highlight" // Add an accessible label for screen readers
        >
          <JumpIcon
            data-testid="zoom-to-highlight-btn"
            brandColor={jumpIconColor}
            toggleZoomHighlight={floorZoomMode !== FloorZoomMode.ZOOMIN}
            onClick={e => {
              e.preventDefault();
              handleZoomToHighlight(floorZoomMode, setFloorZoomMode, setFloorRotation);
            }}
          />
        </div>
      </Grid2>
      <Grid2>
        <IconContainer
          icon={Rotate90DegreesCw}
          brandColor={jumpIconColor}
          right="0"
          data-testid={"floor-rotate-btn"}
          onClick={() => {
            /* istanbul ignore next */
            setFloorRotation(prev => {
              if (prev === 360) return 60;
              return prev + 60;
            });
          }}
        />
      </Grid2>
    </Grid2>
  );
}
